export default function DemoNotice() {
  return (
    <div role="status" className="border-b border-amber-200 bg-amber-50 px-3 py-2 text-center text-xs font-semibold text-amber-950">
      Development demo — synthetic test accounts and data only. Not approved for real-patient clinical use.
    </div>
  );
}
